import {useEffect, useState} from 'react';
import {useGetLoggedInUserQuery} from "@mwServices/User";

const useEnforceLoggedIn = (): any | null => {
    const userResponse = useGetLoggedInUserQuery();
    const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);

    useEffect(() => {
        if(!userResponse.isLoading){
            if(userResponse.isError || (userResponse.data && userResponse.data.user === null)) {
                setIsLoggedIn(false);
                console.log('Failed user, redirect to login.');
                window.location.href = "/login";
            }else{
                setIsLoggedIn(true);
            }
        }
    }, [userResponse]);

    return { 
        isLoggedIn, 
        user: userResponse?.data?.user, 
        isSuccess: userResponse?.isSuccess, 
        isLoading: userResponse?.isLoading, 
        isError: userResponse?.isError, 
        isFetching: userResponse?.isError, 
    };
}

export default useEnforceLoggedIn;